// Shared by the page and legacy modal entry points. Keep old deep links working.
export function firstSettingsParam(value) {
  return Array.isArray(value) ? value[0] : value;
}

export function isSettingsIndexSection(value) {
  const section = firstSettingsParam(value);
  return !section || section === 'index' || section === 'main';
}

export function normalizeSettingsSection(value) {
  const section = firstSettingsParam(value);
  return ({ profile: 'account', main: 'appearance', billing: 'subscription', 'default-model': 'general', 'remote-projects': 'remote' })[section] || section || 'appearance';
}

export function settingsEntrySection(modalName, props = {}) {
  const explicit = props.tab || props.initialScreen;
  if (explicit) return explicit;
  return modalName === 'SettingsModalMobile' ? 'index' : 'appearance';
}

export function getSettingsSections({ isGhost, isPlus, platform }, t) {
  const section = (id, label, icon, group) => ({ id, title: t(`settingsWeb.${label}`), icon, group, description: t(`settingsPage.descriptions.${id}`), searchTerms: t(`settingsPage.searchTerms.${id}`) });
  return [
    {
      ...section('appearance', 'appearance', 'palette', 'preferences'),
      searchTerms: [
        t('settingsPage.searchTerms.appearance'),
        ...(['ios', 'android'].includes(platform) ? [
          t('settings.appearance.keepScreenAwake.title'),
          t('settings.appearance.keepScreenAwake.subtitle'),
        ] : []),
      ].join(' '),
    },
    ...(platform === 'macos' && !isGhost ? [
      section('mac', 'macApp', 'laptop', 'preferences'),
      section('remote', 'remoteAccess', 'mobile-screen', 'preferences'),
    ] : []),
    section('general', 'general', 'gear', 'preferences'),
    ...(!isGhost ? [
      ...(['ios', 'android'].includes(platform) ? [{ id: 'remote', title: 'Connect to Your Mac', icon: 'laptop', group: 'preferences',
        description: 'Use folders on your Mac from your phone with Remote.', searchTerms: 'remote mac computer connect pair projects folders' }] : []),
      section('personalization', 'personalization', 'sliders', 'preferences'),
      ...(platform === 'macos' ? [{ id: 'plugins', title: 'Plugins', icon: 'puzzle-piece', group: 'tools',
        description: 'Add skills and connected apps to Work on your Mac.', searchTerms: 'plugins skills connections mcp oauth apps integrations' }] : []),
      ...(['web', 'macos'].includes(platform) ? [section('keyboard', 'keyboardShortcuts', 'keyboard', 'preferences')] : []),
      section('account', 'account', 'user-shield', 'account'),
      section('subscription', isPlus ? 'billing' : 'upgrade', 'credit-card', 'account'),
      section('credits', 'credits', 'coins', 'account'),
      section('usage', 'usageHistory', 'chart-line', 'account'),
      ...(isPlus ? [section('earn', 'earn', 'gift', 'account')] : []),
      section('referral', 'referAFriend', 'user-plus', 'account'),
      section('import', 'importLabel', 'file-import', 'tools'),
      section('api', 'apiSettings', 'code-fork', 'tools'),
    ] : []),
    section('help', 'help', 'question-circle', 'tools'),
  ];
}
